import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {compose} from 'redux'
import {
  Avatar,
  IconButton,
  Tooltip,
  PhotoCameraIcon,
  providePopup
} from 'rambler-ui'
import withAvatars from 'models/avatars'
import Avatars from '../Avatars'
import styles from './styles.css'

class UserCard extends PureComponent {
  static propTypes = {
    avatars: PropTypes.array,
    activeAvatarSrc: PropTypes.string,
    type: PropTypes.string,
    display: PropTypes.object,
    children: PropTypes.node,
    setEditable: PropTypes.func.isRequired,
    openPopup: PropTypes.func.isRequired,
    uploadAvatar: PropTypes.func.isRequired
  }

  openAvatars = async () => {
    const {avatars, openPopup} = this.props

    if (avatars.length > 0) {
      try {
        await openPopup((onResolve, onReject) => (
          <Avatars onResolve={onResolve} onReject={onReject} />
        )).closed
      } catch (error) {} // eslint-disable-line no-empty
    }
  }

  render() {
    const {
      avatars,
      activeAvatarSrc,
      display,
      children,
      setEditable,
      uploadAvatar
    } = this.props

    const hasAvatar = avatars.length > 0

    return (
      <article className={styles.root}>
        <Tooltip position="bottom" content="Обновить фото в профиле">
          <label className={styles.image} htmlFor="uploadFirstImage">
            <Avatar
              className={styles.editable}
              src={activeAvatarSrc}
              onClick={this.openAvatars}
              data-cerber-id={`profile::avatar::${
                !hasAvatar ? 'upload_avatar' : 'uploaded_avatar_click'
              }`}
            />
            <div className={styles.changeImage}>
              <IconButton
                type="secondary"
                size={30}
                aria-label="Обновить фото в профиле"
                /* eslint-disable-next-line jsx-a11y/label-has-associated-control */
                container={<label htmlFor="uploadFirstImage" />}
                onClick={this.openAvatars}>
                <PhotoCameraIcon color="#6674a6" />
              </IconButton>
            </div>
            {!hasAvatar && (
              <input
                type="file"
                id="uploadFirstImage"
                onChange={uploadAvatar}
                accept="image/bmp,image/jpeg,image/png"
              />
            )}
          </label>
        </Tooltip>
        <div className={styles.side}>
          {display.displayName ? (
            <h1>{display.displayName}</h1>
          ) : (
            <button type="button" onClick={() => setEditable('name')}>
              Кажется, вы забыли указать свои имя и фамилию
            </button>
          )}
          {children}
        </div>
      </article>
    )
  }
}

export default compose(providePopup, withAvatars)(UserCard)
